export default __webpack_public_path__ + "static/media/optimism.34412af2.svg";